'use client';
import { Carousel, Col, Row } from 'react-bootstrap';
import { NextArrow } from '@/components/Icons/NextArrow';
import Image from 'next/image';
import './carousel.scss';
import { urlForImage } from '@/sanity/lib/utils';

import { GroupedItems } from '../../util';
import Link from 'next/link';

type CarouselComponentProps = {
  CarouselSlides: GroupedItems | [];
};

export default function CarouselComponent({
  CarouselSlides,
}: CarouselComponentProps) {
  return (
    <div
      className="d-flex slider"
      role="region"
      aria-labelledby="carousel-heading"
    >
      <Carousel
        nextIcon={
          <NextArrow aria-label="Next slide" aria-controls="carousel-content" />
        }
        prevIcon={
          <NextArrow
            aria-label="Previous slide"
            aria-controls="carousel-content"
          />
        }
        indicators={false}
        controls={true}
        interval={3000}
        slide={true}
        fade={false}
        pause="hover"
        aria-live="polite"
      >
        {CarouselSlides.map((slide, slideIndex) => (
          <Carousel.Item key={slideIndex}>
            <Row>
              {slide.map((item, index) => (
                <Col key={index} sm={6}>
                  <Link className="text-decoration-none item-box" href={''}>
                    <div className="content">
                      <Image
                        src="/n_icons/quotes.webp"
                        alt="quotes"
                        height={16}
                        width={18}
                        quality={100}
                        sizes="10vw"
                        className="quotes-icon"
                      />
                      <p>{item.message}</p>
                    </div>
                    <Image
                      src={
                        (urlForImage(item.logo)?.url() as string) ||
                        '/n_images/default-blog.jpg'
                      }
                      alt={item.message}
                      className="article_image"
                      width={500}
                      height={200}
                      quality={100}
                      sizes="30vw"
                    />
                  </Link>
                </Col>
              ))}
            </Row>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}
